import { ApiError } from '../api/client';
import { t } from '../i18n';

/**
 * Turn any thrown value into one user-facing sentence.
 *
 * The server's own message is appended only when it adds information — for
 * validation errors and 5xx, where "check the data" alone is useless.
 */
export function describeError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return t('auth.sessionExpired');
    if (error.status === 403) return t('error.forbidden');
    if (error.status === 404) return t('error.notFound');
    if (error.status === 422 || error.code === 'validation') {
      return `${t('error.validation')} ${error.message}`.trim();
    }
    if (error.status >= 500) return `${t('error.server')} ${error.message}`.trim();
    return error.message;
  }
  // fetch() rejects with TypeError on DNS/TLS/connection failure.
  if (error instanceof TypeError) return t('error.network');
  if (error instanceof Error) return error.message;
  return t('error.unknown');
}

/** Map a failed login/register to a specific hint when the server says why. */
export function describeAuthError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return t('auth.invalidCredentials');
    if (error.status === 409) return t('auth.emailTaken');
    if (error.status === 403) return t('auth.registerDisabled');
    if (error.status === 422) return `${t('error.validation')} ${error.message}`.trim();
  }
  return describeError(error);
}
